import { HttpClient, HttpClientRequest, HttpClientResponse } from '@effect/platform';
import { Address, DashboardData, makeAddressSync, ProtocolKey } from '@silo/types';
import { useSiloWeb3 } from '@silo/web3';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Effect, pipe } from 'effect';

export const dashboardDataKey = 'dashboardData';

type DashboardDataKey = [key: typeof dashboardDataKey, protocolKey: ProtocolKey, user: Address];

export function useQueryDashboardData() {
  const { protocolInstance, account } = useSiloWeb3();

  const user = account ? makeAddressSync(account) : undefined;

  return useQuery({
    queryKey: [dashboardDataKey, protocolInstance!, user!],
    queryFn: queryDashboardData,
    enabled: !!protocolInstance && !!user,
  });
}

const queryDashboardData: QueryFunction<DashboardData, DashboardDataKey> = async ({
  queryKey: [_, protocolKey, user],
}) => {
  const result = await pipe(
    HttpClientRequest.get('/api/dashboard'),
    HttpClientRequest.appendUrlParams({ protocol: protocolKey, user }),
    HttpClient.fetchOk,
    Effect.andThen(HttpClientResponse.schemaBodyJson(DashboardData)),
    Effect.scoped,
    Effect.runPromise
  );

  return result;
};
